import React from 'react';
import { Form } from 'src/components/Antd';
import Co from 'src/constrains/AdvancedFilters/Collapse';
import { TermsAndConditions } from 'src/constrains/AdvancedFilters/Components';
import { EInclude } from 'src/constrains/AdvancedFilters/Components/CommonRadioMulSelect';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import { get } from 'lodash';

const Item = Form.Item;

const _TermsAndConditions = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    rootName,
    form,
    noStyle,
    radioName,
    selectName,
    selectOptions,
    defaultState,
    ...rest
  } = props;
  const handleOnReset = () => {
    form.setFieldsValue(defaultState);
  };
  return (
    <Item
      noStyle
      shouldUpdate={(p, c) => {
        const touched = form.isFieldTouched(rootName);
        return touched; //|| cv !== pv;
      }}>
      {(f) => {
        const { getFieldValue } = f;
        const type = getFieldValue(radioName);
        const handleOnClose = () => {
          form
            .validateFields([radioName, selectName])
            .then(() => {
              //console.log('没错');
            })
            .catch((r) => {
              handleOnReset();
            });
        };
        const selectedUuid = getFieldValue(selectName) || [];

        const allTcs = (selectOptions || []).reduce((p, c) => {
          const tcs = get(c, 'termConditions') || [];
          return [...p, ...tcs];
        }, []);
        const selectTcs = selectedUuid.map((uuid) => {
          const item = allTcs.find((option) => {
            return option.uuid === uuid;
          });
          if (item) {
            return item.name;
          }
          return '';
        });

        const hasData = !!type;

        const textGenerator = () => {
          const prefix = {
            [EInclude.any]: getI18n('customerList.tacsApplied.eInclude.any'),
            [EInclude.all]: getI18n('customerList.tacsApplied.eInclude.all'),
            // [EInclude.EXCLUDE_ANY_SELECTED]: getI18n(
            //   'customerList.promotionApplied.eInclude.EXCLUDE_ANY_SELECTED',
            // ),
            // [EInclude.EXCLUDE_ALL_SELECTED]: getI18n(
            //   'customerList.promotionApplied.eInclude.EXCLUDE_ALL_SELECTED',
            // ),
          };
          if (hasData) {
            return `${prefix[type] || ''} (${selectTcs.join(',')})`;
          }
          return '';
        };
        return (
          <Co
            header={
              <div>
                {getI18n('customerTag.settings.termsandconditionsconsent')}
              </div>
            }
            displayText={textGenerator()}
            hasData={hasData}
            onClose={handleOnClose}
            onClear={handleOnReset}>
            <TermsAndConditions
              noStyle={noStyle}
              selectName={selectName}
              selectOptions={selectOptions || []}
              radioName={radioName}
              {...rest}
            />
          </Co>
        );
      }}
    </Item>
  );
};
export default _TermsAndConditions;
